import { z } from 'zod';
import { createPaginatedSchema, paginationQueryParamsSchema } from '../common/index.js';
export var EventAttendanceStatusEnum;
(function (EventAttendanceStatusEnum) {
    EventAttendanceStatusEnum["ATTENDED"] = "Attended";
    EventAttendanceStatusEnum["NOT_ATTENDED"] = "Not Attended";
    EventAttendanceStatusEnum["REGISTERED"] = "Registered";
    EventAttendanceStatusEnum["CANCELLED"] = "Cancelled";
})(EventAttendanceStatusEnum || (EventAttendanceStatusEnum = {}));
export const eventAttendanceSchema = z.object({
    attendee_id: z.string(),
    event_id: z.string(),
    event_name: z.string(),
    status: z.enum(EventAttendanceStatusEnum),
    event_start: z.iso.datetime(),
    event_is_online: z.boolean(),
    timezone: z.string(),
    event_featured_photo: z.string(),
});
export var UserEventAttendanceQueryParamsSortEnum;
(function (UserEventAttendanceQueryParamsSortEnum) {
    UserEventAttendanceQueryParamsSortEnum["EVENT_START_ASC"] = "event_start";
    UserEventAttendanceQueryParamsSortEnum["EVENT_START_DESC"] = "-event_start";
    UserEventAttendanceQueryParamsSortEnum["EVENT_NAME_ASC"] = "event_name";
    UserEventAttendanceQueryParamsSortEnum["EVENT_NAME_DESC"] = "-event_name";
    UserEventAttendanceQueryParamsSortEnum["STATUS_ASC"] = "status";
    UserEventAttendanceQueryParamsSortEnum["STATUS_DESC"] = "-status";
})(UserEventAttendanceQueryParamsSortEnum || (UserEventAttendanceQueryParamsSortEnum = {}));
export const userEventAttendanceQueryParamsSchema = paginationQueryParamsSchema.extend({
    event_is_online: z.literal(['true', 'false']).optional(),
    event_start_gte: z.iso.datetime().optional(),
    event_start_lte: z.iso.datetime().optional(),
    sort: z.enum(UserEventAttendanceQueryParamsSortEnum).optional(),
});
export const paginatedEventAttendanceSchema = createPaginatedSchema(eventAttendanceSchema);
